module.exports = __webpack_public_path__ + "static/media/ODS01.989d54ea.jpg";